<template>
  <div class="memoryBank">
    <!-- <myTitle til="记忆库"></myTitle> -->
    <div class="main">
      <!-- <router-view></router-view> -->
      <memoryTab new_="记忆库" merage="记忆库" :tableData="tableData" @search="search" @goSort="goSort"></memoryTab>
      <el-pagination class="page" background layout="total,prev, pager, next" :total="totalRows" :page-size="20"
        :pager-count="5" prev-text="上一页" next-text="下一页" :current-page.sync="currentPage"
        @current-change="handleCurrentChange"></el-pagination>
    </div>
  </div>
</template>

<script>

import myTitle from "@/common/title.vue";
import memoryTab from "@/views/memory/memoryTab.vue";
export default {
  name: "memoryBank",
  beforeRouteEnter (to, from, next) {
    if (from.path != "/") {
      // 如果不是刷新则赋值1
      sessionStorage.removeItem("myCurrentPage");
    }
    next();
  },
  data () {
    return {
      elMain: {},
      tabIf: true,
      clas: true,
      tableData: [],
      currentPage: "",
      totalRows: 0, // 分页数据总数
      filterName: "",
      sort: ""
    };
  },
  components: {
    myTitle,
    memoryTab
  },
  created () {
    this.currentPage = Number(sessionStorage.getItem("myCurrentPage")) || 1;
    this.getPage(this.currentPage);
  },
  methods: {
    goSort (data) {
      this.sort = data;
      this.getPage(this.currentPage, this.filterName, data);
    },

    // 搜索
    search (data) {
      this.filterName = data;
      this.currentPage = 1;
      sessionStorage.setItem("myCurrentPage", 1);
      this.getPage("1", data);
    },
    // 跳转页
    handleCurrentChange (val) {
      this.getPage(val, this.filterName, this.sort);
      sessionStorage.setItem("myCurrentPage", val); // 将页码存sessionStorage，刷新还在当前页
    },
    // 分页加载数据
    getPage (page, search, sort) {
      var that = this;
      // console.log(sort==true,"sort")
      for (let propName in search) {
        if (search[propName] === "") {
          delete search[propName];
        }
      }
      let filter = {
        company_code: localStorage.myCompanyCode,
        platformType: this.$platformType
      }
      if (search) {
        filter = {...search,...filter}
      }
      var params = {
        page: page,
        rows: 20,
        filter,
        sort: sort || { create_time: "desc" }
      };
      this.catReq1Service("/api/v1/memory/queryPage", params).then(function (response) {
        if (!response.success) {
          return;
        }
        if (response.list == null) {
          response.list = [];
        }
        that.totalRows = response.totalRows;
        response.list.forEach(item => {
          if (item.status === 2) {
            item.sentCount = "正在统计中...";
          }
          item.createTime = that.dateReg(item.createTime);
        });
        that.tableData = response.list;
        if (that.currentPage > 1 && that.tableData.length < 1) {
          sessionStorage.myCurrentPage = sessionStorage.myCurrentPage - 1;
          that.getPage(
            sessionStorage.myCurrentPage,
            that.filterName,
            that.sort
          );
        }
      });
    },
    bank () {
      this.tabIf = true;
      this.clas = true;
    },
    library () {
      this.tabIf = false;
      this.clas = false;
      // this.elMain.background = "red;";
      // this.elMain.border = "1px solid rgba(87, 122, 188, 1);";
      // this.elMain.color = "rgba(87, 122, 188, 1);";
    }
  }
};
</script>
<style lang="less" scoped>
.memoryBank {
  height: 100%;
  height: calc(100% - 65px);
  // overflow-y: auto;
  .main {
    overflow: hidden;
    border-radius: 6px;
    background: #f5f4f4;
    padding: 20px;
    padding-top: 10px;
    padding-bottom: 45px;
    position: relative;
    height: 100%;
    /* 页码样式开始 */
    /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
      // 页码点击效果
      // background: rgba(69, 69, 69, 1);
      color: rgba(255, 255, 255, 1);
      border: 0px;
    }
    /deep/.el-pager li {
      // 页码样式
      min-width: 30px;
      height: 30px;
      border: 1px solid rgba(187, 187, 187, 1);
      border-radius: 2px;
      background: transparent;
      line-height: 30px;
      font-size: 14px;
      font-weight: 400;
    }
    /deep/.el-pagination button {
      // 页码上下页样式
      width: 68px;
      height: 30px;
      border: 1px solid rgba(187, 187, 187, 1);
      border-radius: 2px;
      line-height: 30px;
      font-size: 14px;
      background: transparent;
      color: rgba(102, 102, 102, 1);
      font-weight: 400;
    }
    /deep/.el-pagination button:hover {
      border: 1px solid rgba(128, 128, 128, 1);
    }
    /deep/.el-pagination button:active {
      background: rgba(224, 237, 252, 1);
      border: 1px solid rgba(187, 187, 187, 1);
    }
    .page {
      // margin-top: 30px;
      float: right;
      position: absolute;
      bottom: 20px;
      right: 20px;
    }
    /* 页码样式结束 */
  }
}
</style>